import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16377bbe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component join" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "회원가입", -1))
const _hoisted_3 = { class: "cad-option-box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "withCAD", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "circle" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "withoutCAD", -1))
const _hoisted_10 = { class: "btn-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "cad-option",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setGroupId(1)))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["radio_btn", {active: _ctx.inputData.data.group.group_id === 1}])
        }, _hoisted_5, 2),
        _hoisted_6
      ]),
      _createElementVNode("div", {
        class: "cad-option",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setGroupId(3)))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["radio_btn", {active: _ctx.inputData.data.group.group_id === 3}])
        }, _hoisted_8, 2),
        _hoisted_9
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["id-box focusable", {'caution':_ctx.duplicateMessage!=''&&!_ctx.duplicateCheck}])
    }, [
      _withDirectives(_createElementVNode("input", {
        type: "text",
        class: "id-box input__box",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputData.data.user_id) = $event)),
        spellcheck: "false",
        placeholder: "아이디*",
        onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.duplicateMessage=''))
      }, null, 544), [
        [_vModelText, _ctx.inputData.data.user_id]
      ]),
      _createElementVNode("button", {
        class: "check-btn",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.duplicateConfirm()))
      }, "중복확인"),
      _createElementVNode("p", {
        class: _normalizeClass(["msg", {'caution':_ctx.duplicateMessage!=''&&!_ctx.duplicateCheck}])
      }, _toDisplayString(_ctx.duplicateMessage), 3)
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass({'caution':_ctx.passwordMessage!=''})
    }, [
      _withDirectives(_createElementVNode("input", {
        class: "input__box",
        type: "password",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.inputData.passwd) = $event)),
        onBlur: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.validatePassword && _ctx.validatePassword(...args))),
        onKeyup: _cache[7] || (_cache[7] = ($event: any) => (_ctx.passwordMessage='')),
        placeholder: "비밀번호*"
      }, null, 544), [
        [_vModelText, _ctx.inputData.passwd]
      ]),
      _createElementVNode("p", {
        class: _normalizeClass(["msg", {'caution':_ctx.passwordMessage!=''}])
      }, _toDisplayString(_ctx.passwordMessage), 3)
    ], 2),
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("input", {
        class: "input__box",
        type: "text",
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.inputData.data.name) = $event)),
        spellcheck: "false",
        placeholder: "이름"
      }, null, 512), [
        [_vModelText, _ctx.inputData.data.name]
      ])
    ]),
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("input", {
        class: "input__box",
        type: "text",
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.inputData.data.number) = $event)),
        spellcheck: "false",
        placeholder: "연락처"
      }, null, 512), [
        [_vModelText, _ctx.inputData.data.number]
      ])
    ]),
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("input", {
        class: "input__box",
        type: "text",
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.inputData.data.email) = $event)),
        spellcheck: "false",
        placeholder: "이메일"
      }, null, 512), [
        [_vModelText, _ctx.inputData.data.email]
      ])
    ]),
    _createElementVNode("div", null, [
      _withDirectives(_createElementVNode("input", {
        class: "input__box",
        type: "text",
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.inputData.data.division) = $event)),
        spellcheck: "false",
        placeholder: "소속"
      }, null, 512), [
        [_vModelText, _ctx.inputData.data.division]
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("button", {
        class: "button__blue",
        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.setUser()))
      }, "회원가입"),
      _createElementVNode("button", {
        class: "button__gray",
        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.movePage()))
      }, "취소")
    ])
  ]))
}